module.exports = __webpack_public_path__ + "static/media/ic_accept_all.0ca62b63.svg";